import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import { scrollToTop } from '../../assets/ts/general/general'
import Tabs from '../../components/tabs/tabs'
import usePageTitle from '../../hooks/use-page-title'
import PageHeader from '../../layouts/header/page-header'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import ContentManagement from './content-management/content-management'
import MetadataManagement from './metadata-management/metadata-management'
import PascodeConfiguration from './pascode-configuration/pascode-configuration'
import ReleaseNotes from './release-notes/release-notes'
import './settings.css'
import SiteFeedback from './site-feedback/site-feedback'
import UserManagement from './user-management/user-management'

const Settings = (props: any) => {
  usePageTitle(PAGE_TITLE.SETTINGS)
  const navigate = useNavigate()
  const roleContext = useContext(RoleContext)
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const { fetchData, fetchRNLTDMetdata } = useContext(MetadataContext)
  const [activeTab, setActiveTab] = useState<number>()
  const { multiplePopup, setMultiplePopup } = useContext(UserContext)

  const handleTabSelect = (index) => {
    setSelectedTabIndex(index)
  }
  useEffect(() => {
    setMultiplePopup()
  }, [selectedTabIndex, activeTab])
  const doNotDenyAccess =
    roleContext.firstLevelPermission ||
    roleContext.fourthLevelPermission ||
    roleContext.secondLevelPermission ||
    roleContext.thirdLevelPermission

  const tableitems = [
    {
      content: <ContentManagement setActiveTab={setActiveTab} />,
      isActive: selectedTabIndex === 0,
      isVisible: roleContext.fourthLevelPermission,
      tabTitle: 'CONTENT MANAGEMENT',
    },
    {
      content: <MetadataManagement setActiveTab={setActiveTab} />,
      isActive: selectedTabIndex === 1,
      isVisible: roleContext.firstLevelPermission,
      tabTitle: 'METADATA MANAGEMENT',
    },
    {
      content: <UserManagement isMenusExpanded={props?.isMenusExpanded} />,
      isActive: selectedTabIndex === 2,
      isVisible: roleContext.secondLevelPermission,
      tabTitle: 'USER MANAGEMENT',
    },

    {
      content: <PascodeConfiguration />,
      isActive: selectedTabIndex === 3,
      isVisible: roleContext.thirdLevelPermission,
      tabTitle: 'PASCODE CONFIGURATION',
    },

    {
      content: <ReleaseNotes />,
      isActive: selectedTabIndex === 4,
      isVisible: roleContext.isSiteAdmin || roleContext.isCPOwner,
      tabTitle: 'RELEASE NOTES',
    },

    {
      content: <SiteFeedback />,
      isActive: selectedTabIndex === 5,
      isVisible: roleContext.fourthLevelPermission,
      tabTitle: 'SITE FEEDBACK',
    },
  ]
  if (!roleContext.isLoading) {
    if (!doNotDenyAccess) {
      navigate('/accessdenied')
    }
  }

  useEffect(() => {
    return () => {
      fetchData() // This will run when the component unmounts to update soft deleted items
      fetchRNLTDMetdata() // This will run when the component unmounts to update RNLTD metadataContext
    }
  }, [])

  useEffect(() => {
    setMultiplePopup()
  }, [selectedTabIndex, activeTab])

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  
  return (
    <>
      <div id='scroll'></div>
      <PageHeader icon='icon-menusettings me-1 color-primary font-16' name='Settings' />
      <div className='container'>
        <div className='row'>
          <Tabs
            anchorclass='font-15 poppins-semibold '
            className='mb-2 shadow card cards-lg px-2 pt-2 border3 settingstabs xl'
            items={tableitems}
            onTabSelected={handleTabSelect}
            tabsul='overflow-auto lg'
          />
        </div>
      </div>
    </>
  )
}
export default Settings
